import { render, staticRenderFns } from "./VerticalLayoutNoThumbnail.vue?vue&type=template&id=27f3b1c6&scoped=true"
import script from "./VerticalLayoutNoThumbnail.vue?vue&type=script&lang=js"
export * from "./VerticalLayoutNoThumbnail.vue?vue&type=script&lang=js"
import style0 from "./VerticalLayoutNoThumbnail.vue?vue&type=style&index=0&id=27f3b1c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f3b1c6",
  null
  
)

export default component.exports